import {useControllers} from '../../../../../common/helpers/react/hooks/useControllers';
import {asNumber} from '../../../../../common/helpers/converters/asNumber';

type Props = { groupId: string }

export default function LockedAgentsCount({groupId}: Props) {
    const controllers = useControllers();
    const groups = controllers.groups;

    controllers.agents.useForceUpdate();

    const groupAgents = groups.getGroupAgents$(asNumber(groupId)).useState() ?? [];
    const agents = groups.getAgents$().useState() ?? [];

    const lockedAgentIds = new Set(agents.filter(it => it.locked === true).map(it => it.id));
    const lockedCount = groupAgents.filter(ga => lockedAgentIds.has(ga.agent)).length;

    return lockedCount > 0 ? <> ({lockedCount})</> : <></>;
}
